import React, { useEffect, useRef } from "react";
import ScheduleListItem from "./ScheduleListItem";

const hasObserver = typeof window !== "undefined" && "IntersectionObserver" in window;

/*
 * A scrollable schedule list that asks for the next page when its end
 * scrolls into view. `empty` is shown once page 1 came back with nothing.
 */
export default function ScheduleFeedList({ feed, className, itemClassName, onOpen, empty }) {
  const rootRef = useRef(null);
  const sentinelRef = useRef(null);
  const { items, hasMore, loading, loadMore } = feed;
  const count = items ? items.length : 0;

  // Re-created after every page, so a sentinel still in view after a short page fires again.
  useEffect(() => {
    if (!hasObserver || !hasMore || loading || !sentinelRef.current) return undefined;
    const observer = new window.IntersectionObserver(
      (entries) => entries.some((entry) => entry.isIntersecting) && loadMore(),
      { root: rootRef.current, rootMargin: "0px 0px 120px 0px" }
    );
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [hasMore, loading, count, loadMore]);

  return (
    <div className={className} ref={rootRef}>
      {items === null ? (
        <div className="app-loader" style={{ minHeight: 120 }}>
          <div className="spinner" />
        </div>
      ) : count === 0 ? (
        empty
      ) : (
        <>
          {items.map((item) => (
            <ScheduleListItem key={item.key} item={item} className={itemClassName} onOpen={onOpen} />
          ))}
          {hasMore && (
            <div className="schedule-feed-more" ref={sentinelRef}>
              {loading ? (
                <div className="spinner spinner-sm" />
              ) : (
                !hasObserver && (
                  <button type="button" className="btn-widget-calendar" onClick={loadMore}>
                    Show more
                  </button>
                )
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
}
